import { z } from "zod";
import {
    ScheduleLifecyclePeriodLockedError,
    scheduleConflictResponseSchema,
} from "@common/schemas/domains/accounting/scheduleLifecycle.schema";
import { ScheduleLifecycleErrorCode } from "@common/types/domains/accounting/schedule";

export type ScheduleConflictResponse = z.infer<
    typeof scheduleConflictResponseSchema
>;

/**
 * Narrows a schedule 409 body to the locked-period shape. Apply and every
 * lifecycle verb answer with it when a journal entry the action would touch
 * falls on or before the entity's lock date; a plain `{ message }` 409 is any
 * other conflict.
 */
export function isScheduleLifecyclePeriodLockedError(
    body: ScheduleConflictResponse,
): body is ScheduleLifecyclePeriodLockedError {
    return (
        "errorCode" in body &&
        body.errorCode === ScheduleLifecycleErrorCode.periodLocked
    );
}
